import { render, staticRenderFns } from "./InterviewType.vue?vue&type=template&id=af9b9760&scoped=true"
import script from "./InterviewType.vue?vue&type=script&lang=js"
export * from "./InterviewType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9b9760",
  null
  
)

export default component.exports